<template>
  <div class="form-step-1">
    <div class="section-subtitle">Номер телефона</div>
    <form class="auth-form">
      <div class="auth-form--wrap">
        <div class="input-label">Ваш номер телефона</div>
        <v-text-field
          id="regPhone"
          v-model="login"
          v-mask="'+7 (###) ###-####'"
          :disabled="loading"
          :rules="[loginRules.phone]"
          autofocus
          dense
          outlined
          placeholder="+7 (9__)___-__-__"
          prepend-inner-icon="mdi-phone-outline"
          required
          type="text"
        />
      </div>
      <div class="auth-form--wrap">
        <div class="input-label">Пригласительный код</div>
        <v-text-field
          v-model="inviteCodeLocal"
          :disabled="loading"
          dense
          outlined
          required
          type="text"
        />
      </div>
      <div class="size-14 justify-start">
        <v-checkbox
          v-model="checkedPers"
          :disabled="loading"
          color="#0464AC"
          readonly
          required
          @click="ShowDialogPers"
        >
          <template v-slot:label>
            <div>
              Я согласен с&nbsp;<a
                class="text-decoration-none font-weight-bold"
                href=""
                @click="ShowDialogPers"
                >Обработкой персональных данных</a
              >
            </div>
          </template>
        </v-checkbox>
        <v-checkbox
          v-model="checkedRules"
          :disabled="loading"
          color="#0464AC"
          readonly
          required
          style="margin-top: 0"
          @click="ShowDialogRules"
        >
          <template v-slot:label>
            <div>
              Я согласен с&nbsp;<a
                class="text-decoration-none font-weight-bold"
                href=""
                @click="ShowDialogRules"
                >Правилами мотивационной программы</a
              >
            </div>
          </template>
        </v-checkbox>
      </div>
      <v-btn
        :disabled="!isValid || loading"
        class="w-100 btn-blue mb-4"
        color="primary"
        @click="Submit"
      >
        Продолжить
      </v-btn>
    </form>

    <div class="text-gray size-14">
      Уже зарегистрированы?<a
        class="text-decoration-none ml-2"
        href=""
        @click="GoTo($event, '/login')"
        >Вход</a
      >
    </div>

    <v-dialog v-if="pers" v-model="dialogPers" width="500">
      <v-card>
        <v-card-title
          class="headline primary white--text"
          primary-title
          v-html="pers.title"
        ></v-card-title>
        <v-card-text v-html="pers.content"></v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="default"
            @click="
              dialogPers = false;
              checkedPers = false;
            "
            >Отклонить</v-btn
          >
          <v-btn
            color="primary"
            @click="
              dialogPers = false;
              checkedPers = true;
            "
            >Принять</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="rules" v-model="dialogRules" width="500">
      <v-card>
        <v-card-title
          class="headline primary white--text"
          primary-title
          v-html="rules.title"
        ></v-card-title>
        <v-card-text v-html="rules.content"></v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="default"
            @click="
              dialogRules = false;
              checkedRules = false;
            "
          >Отклонить</v-btn
          >
          <v-btn
            color="primary"
            @click="
              dialogRules = false;
              checkedRules = true;
            "
          >Принять</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'FormStep1',
  props: ['loading', 'inviteCode'],
  data() {
    return {
      rules: '',
      dialogRules: false,
      checkedRules: false,
      pers: '',
      dialogPers: false,
      checkedPers: false,
      login: '',
      loginRules: {
        phone: v => (v.length && v.length >= 17)
          || 'Номер телефона заполнен не полностью',
      },
      inviteCodeLocal: '',
    };
  },
  computed: {
    isValid() {
      return this.login.length >= 17 && this.checkedPers && this.checkedRules;
    },
  },
  methods: {
    /** Переход по ссылкам с остановкой перезагрузки страницы для ссылок */
    async GoTo(event, path) {
      event.preventDefault();
      await this.$router.push(path);
    },
    /** Показать диалог Персональных данных */
    ShowDialogPers(e = null) {
      e && e.preventDefault();
      this.dialogPers = true;
    },
    /** Показать диалог Правил */
    ShowDialogRules(e = null) {
      e && e.preventDefault();
      this.dialogRules = true;
    },
    /** Предзагрузка данных в форму если участник добавлен в админке */
    LoadPages(url) {
      const app = this;
      app.$store.getters.axl
        .post('/pages/api/pages', { url })
        .then((response) => {
          app.$data[url] = response.data.page;
        });
    },
    Submit() {
      this.$emit('submit', {
        login: this.login,
        checkedPers: this.checkedPers,
        invite_code: this.inviteCodeLocal,
      });
    },
  },
  mounted() {
    this.LoadPages('pers');
    this.LoadPages('rules');
    this.inviteCodeLocal = this.inviteCode;
  },
};
</script>

<style lang="scss" scoped></style>
